module.exports = __webpack_public_path__ + "7f93906f3ea61157566fd8883412b6fa.svg";